/**
 * Add CSS selector prefix
 */
 window.ap = window.ap || function(domElem, prefix) {
     return (prefix || '.') + domElem;
 };

var FoldingCategories = function(domElement) {
    this.rootElement = document.querySelector('body');
    this.domElement = domElement;
    this.containerElement = domElement.parentElement;
    this.containerClass = 'sector-dropdown';
    this.categoryClass = 'category';
    this.subcategoryClass = 'subcategories';
    this.selectedClass = 'selected';
    this.hiddenClass = 'hidden';
    this.selectedTitleClass = "category-selected";
    this.dropdownDefaultTitle = 'Sectors';
    this.dropdownTitleId = 'sector-dropdown-title';
    this.dropdownTitleMany = ' options selected';
    this.dropdownCategorySelector = '.category-name';
    this.dropdownCancelClass = 'dropdown-cancel';
    this.dropdownApplyClass = 'dropdown-apply';
    this.dropdownToggleElement = '';
    this.clearElement = null;
    this.onClear = null;
    this.initialState = null;
    this.isOpen = false;

    this.enableSaveState = true;
    this.enableClear = true;
    this.enableChildrenCategories = false;
    this.enableParentSelection = true;
    this.enableSelectionCounter = false;
    this.enableDropdownTitle = true;

    this.onDropdownApply = function() {
        if (this.enableSaveState) {
            this.initialState = this.domElement.cloneNode(true);
        }
        var dropdownIcon = this.containerElement.querySelector('.dropdown-icon');
        dropdownIcon.classList.add('closed');
        this.isOpen = false;
    }

    this.closeDropdown = function() {
        this.isOpen = false;
        var dropdownIcon = this.containerElement.querySelector('.dropdown-icon');
        dropdownIcon.classList.add('closed');
        if (this.enableSaveState) {
            this.cancelModifications();
        }
    }

    this.onDropdownToggle = function() {
        var wasOpen = this.isOpen;
        this.isOpen = !this.isOpen;
        var dropdownIcon = this.containerElement.querySelector('.dropdown-icon');
        if (!wasOpen) {
            var event = new CustomEvent('dropdown-opened', {detail: this.containerClass});
            this.rootElement.dispatchEvent(event);
            dropdownIcon.classList.remove('closed');
            if (this.enableSaveState)
                this.initialState = this.domElement.cloneNode(true);
        } else if (wasOpen) {
            dropdownIcon.classList.add('closed');
            if (this.enableSaveState) {
                this.cancelModifications();
            }
        }
    }

    this.cancelModifications = function() {
        if (this.enableSaveState && this.initialState) {
            this.domElement.innerHTML = this.initialState.innerHTML;

            // Force checkboxes to unchecked first to fix a weird DOM cache issue
            var checkboxElements = this.domElement.querySelectorAll('.checkbox');
            for (var i = 0; i < checkboxElements.length; i++) {
                checkboxElements[i].checked = false;
                checkboxElements[i].indeterminate = false;
            }

            var selectedCategoriesElements = this.domElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass));
            for (var i = 0; i < selectedCategoriesElements.length; i++) {
                var checkboxElement = selectedCategoriesElements[i].querySelector('.checkbox');
                var subcategoryElement = selectedCategoriesElements[i].querySelector(ap(this.subcategoryClass));
                if (subcategoryElement) {
                    var subcategoriesCount = subcategoryElement.querySelectorAll('.checkbox').length;
                    var selectedCount = subcategoryElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass)).length;

                    if (selectedCount < subcategoriesCount) {
                        if (selectedCount > 0) {
                            checkboxElement.indeterminate = true;
                        }
                    } else {
                        checkboxElement.checked = true;
                    }
                } else {
                    checkboxElement.checked = true;
                }
            }
            this.domElement = this.containerElement.querySelector(ap(this.containerClass));
            var refreshBtnList = this.domElement.querySelectorAll('.refresh-jobs');
            for (var i = 0; i < refreshBtnList.length; i++) {
                refreshBtnList[i].addEventListener('click', jobsListingManager.refreshResults.bind(jobsListingManager));
            }
            this.bindCategoriesEvents();
            if (this.enableDropdownTitle) this.updateDropdownTitle();
        }
    }

    this.clearModifications = function() {
        this.isOpen = false;
        var dropdownIcon = this.containerElement.querySelector('.dropdown-icon');
        dropdownIcon.classList.add('closed');

        var checkboxElements = this.domElement.querySelectorAll('.checkbox');
        for (var i = 0; i < checkboxElements.length; i++) {
            checkboxElements[i].checked = false;
            checkboxElements[i].indeterminate = false;
        }
        var selectedCategoriesElements = this.domElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass));
        for (var i = 0; i < selectedCategoriesElements.length; i++) {
            selectedCategoriesElements[i].classList.remove(this.selectedClass);
        }
        var subCategoriesElements = this.domElement.querySelectorAll(ap(this.subcategoryClass));
        for (var i = 0; i < subCategoriesElements.length; i++) {
            subCategoriesElements[i].classList.add(this.hiddenClass);
        }
        var dropdownIconElements = this.domElement.querySelectorAll('.dropdown-icon');
        for (var i = 0; i < dropdownIconElements.length; i++) {
            dropdownIconElements[i].classList.add('closed');
        }

        if (this.enableSaveState) {
            this.initialState = this.domElement.cloneNode(true);
        }

        if (this.enableSelectionCounter) this.updateSelectionCounter();
        if (this.enableDropdownTitle) this.updateDropdownTitle();
        if (jobsListingManager.refreshResults) jobsListingManager.refreshResults();
    }

    this.updateDropdownTitle = function() {
        var categoryElements = this.domElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass) + ':not(.parent-category)');
        var dropdownTitleElement = document.querySelector(ap(this.dropdownTitleId, '#'));

        if (categoryElements.length > 0) {
            if (this.enableClear && this.clearElement) {
                this.clearElement.classList.remove('hidden');
            }
        }
        if (categoryElements.length > 1) {
            dropdownTitleElement.classList.add(this.selectedTitleClass);
            dropdownTitleElement.innerHTML = categoryElements.length + this.dropdownTitleMany;
        } else if (categoryElements.length === 1) {
            dropdownTitleElement.classList.add(this.selectedTitleClass);
            var categoryName = categoryElements[0].querySelector(this.dropdownCategorySelector).innerHTML;
            dropdownTitleElement.innerHTML = categoryName;
        } else if (categoryElements.length === 0) {
            if (this.enableClear && this.clearElement) {
                this.clearElement.classList.add('hidden');
            }
            dropdownTitleElement.classList.remove(this.selectedTitleClass);
            dropdownTitleElement.innerHTML = this.dropdownDefaultTitle;
        }
    }

    this.updateSelectionCounter = function() {
        var subCategoryElements = this.domElement.querySelectorAll(ap(this.subcategoryClass));
        for (var i = 0; i < subCategoryElements.length; i++) {
            var subCategoryElement = subCategoryElements[i].parentElement;

            var subCategorySelectedCount = subCategoryElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass)).length;
            var selectionCounterElement = subCategoryElement.querySelector('.subselected-count');

            if (subCategorySelectedCount > 0) {
                selectionCounterElement.innerHTML = ' (' + subCategorySelectedCount + ')';
            } else {
                selectionCounterElement.innerHTML = '';
            }
        }
    }

    this.toggleCategory = function(event) {
        var categoryElement = event.target.parentElement.parentElement;
        var subcategoryElement = categoryElement.querySelector(ap(this.subcategoryClass));
        var dropdownIconElement = categoryElement.querySelector('.dropdown-icon');

        if (subcategoryElement.classList.contains(this.hiddenClass)) {
            subcategoryElement.classList.remove(this.hiddenClass);
            dropdownIconElement.classList.remove('closed');
        } else {
            subcategoryElement.classList.add(this.hiddenClass);
            dropdownIconElement.classList.add('closed');
        }
    }

    this.selectCategory = function(event) {
        var element = event.target || event;
        if (element != null && element.classList.contains('checkbox')) {

            element.indeterminate = false;
            var categoryElement = element.parentElement.parentElement;
            if (element.checked) {
                categoryElement.classList.add(this.selectedClass);
            } else {
                categoryElement.classList.remove(this.selectedClass);
            }

            if (this.enableParentSelection) this.selectParent(categoryElement);
            if (this.enableChildrenCategories) this.selectChildren(categoryElement, element.checked);
            if (this.enableSelectionCounter) this.updateSelectionCounter();
            if (this.enableDropdownTitle) this.updateDropdownTitle();
        }
    }

    this.selectParent = function(categoryElement) {
        if (categoryElement.parentElement.classList.contains(this.subcategoryClass)) {
            var parentCategoryElement = categoryElement.parentElement.parentElement;
            var subcategoriesCount = parentCategoryElement.querySelectorAll(ap(this.subcategoryClass) +' .checkbox').length;
            var selectedCount = parentCategoryElement.querySelectorAll(ap(this.subcategoryClass) +' .checkbox:checked').length;

            if (selectedCount > 0) {
                parentCategoryElement.classList.add(this.selectedClass);
                if (selectedCount < subcategoriesCount) {
                    parentCategoryElement.querySelector('.checkbox').checked = false;
                    parentCategoryElement.querySelector('.checkbox').indeterminate = true;
                } else {
                    parentCategoryElement.querySelector('.checkbox').checked = true;
                    parentCategoryElement.querySelector('.checkbox').indeterminate = false;
                }
            } else {
                parentCategoryElement.classList.remove(this.selectedClass);
                parentCategoryElement.querySelector('.checkbox').checked = false;
                parentCategoryElement.querySelector('.checkbox').indeterminate = false;
            }

            this.selectParent(parentCategoryElement);
        }
    }

    this.selectChildren = function(categoryElement, forceSelection) {
        if (categoryElement.querySelector(ap(this.subcategoryClass))) {
            var childrenCategoryElements = categoryElement.querySelectorAll(ap(this.categoryClass));

            for (var i = 0; i < childrenCategoryElements.length; i++) {
                if (categoryElement.classList.contains(this.selectedClass) || forceSelection) {
                    childrenCategoryElements[i].querySelector('.checkbox').checked = true;
                    childrenCategoryElements[i].classList.add(this.selectedClass);
                } else {
                    childrenCategoryElements[i].querySelector('.checkbox').checked = false;
                    childrenCategoryElements[i].classList.remove(this.selectedClass);
                }
                this.selectChildren(childrenCategoryElements[i], forceSelection);
            }

            if (categoryElement.classList.contains(this.selectedClass)) {
                var subcategoryElement = categoryElement.querySelector(ap(this.subcategoryClass));
                var dropdownIconElement = categoryElement.querySelector('.dropdown-icon');

                if (subcategoryElement.classList.contains(this.hiddenClass)) {
                    subcategoryElement.classList.remove(this.hiddenClass);
                    dropdownIconElement.classList.remove('closed');
                }
            }
        }
    }

    this.initStateFromDOM = function() {
        var selectedCategoriesElements = this.domElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass));

        for (var i = 0; i < selectedCategoriesElements.length; i++) {
            var checkboxElement = selectedCategoriesElements[i].querySelector('.checkbox');
            var subcategoryElement = selectedCategoriesElements[i].querySelector(ap(this.subcategoryClass));
            if (subcategoryElement) {
                var subcategoriesCount = subcategoryElement.querySelectorAll('.checkbox').length;
                var selectedCount = subcategoryElement.querySelectorAll(ap(this.categoryClass) + ap(this.selectedClass)).length;

                if (selectedCount < subcategoriesCount) {
                    if (selectedCount > 0) {
                        checkboxElement.indeterminate = true;
                    }
                } else {
                    checkboxElement.checked = true;
                }
            } else {
                checkboxElement.checked = true;
            }
        }
        if (this.enableSaveState)
            this.initialState = this.domElement.cloneNode(true);
    }

    this.bindEvents = function() {
        if (this.dropdownToggleElement) {
            this.dropdownToggleElement.addEventListener('click', this.onDropdownToggle.bind(this));
        }
        this.rootElement.addEventListener('dropdown-opened', (event) => {
            if (event.detail !== this.containerClass) {
                this.closeDropdown();
            }
        });
        this.bindCategoriesEvents();
    }

    this.bindCategoriesEvents = function() {
        var checkboxElements = this.domElement.querySelectorAll('.checkbox');
        var labelElements = this.domElement.querySelectorAll(this.dropdownCategorySelector);
        var dropdownElements = this.domElement.querySelectorAll('.dropdown-icon');

        for (var i = 0; i < labelElements.length; i++) {
            labelElements[i].addEventListener('click', (event) => {
                var checkbox = event.target.parentElement.parentElement.querySelector('.checkbox');
                if (checkbox) {
                    checkbox.click();
                }
            });
        }
        for (var i = 0; i < checkboxElements.length; i++) {
            checkboxElements[i].addEventListener('click', this.selectCategory.bind(this));
        }
        for (var i = 0; i < dropdownElements.length; i++) {
            dropdownElements[i].addEventListener('click', this.toggleCategory.bind(this));
        }

        if (this.enableClear) {
            if (this.clearElement) {
                this.clearElement.addEventListener('click', this.clearModifications.bind(this));
            }
        }

        if (this.enableSaveState) {
            var dropdownCancelElements = this.domElement.querySelectorAll(ap(this.dropdownCancelClass));

            for (var i = 0; i < dropdownCancelElements.length; i++) {
                dropdownCancelElements[i].addEventListener('click', this.onDropdownToggle.bind(this));
            }
        }

        var dropdownApplyElements = this.domElement.querySelectorAll(ap(this.dropdownApplyClass));
        for (var i = 0; i < dropdownApplyElements.length; i++) {
            dropdownApplyElements[i].addEventListener('click', this.onDropdownApply.bind(this));
        }
    }

    this.init = function() {
        this.bindEvents();
        this.initStateFromDOM();
        if (this.enableSelectionCounter) this.updateSelectionCounter();
        if (this.enableDropdownTitle) this.updateDropdownTitle();
    }
}

if (document.querySelector('.sector-dropdown')) {
    var sectorCategories = new FoldingCategories(document.querySelector('.sector-dropdown'));
    sectorCategories.enableChildrenCategories = true;
    sectorCategories.enableSelectionCounter = true;
    sectorCategories.dropdownTitleMany = ' sectors';
    sectorCategories.dropdownToggleElement = document.querySelector('.toggle-sectors');
    sectorCategories.clearElement = document.querySelector('.sector-filter .dropdown-clear-icon');
    sectorCategories.init();
}

if (document.querySelector('.salary-dropdown')) {
    var salaryCategories = new FoldingCategories(document.querySelector('.salary-dropdown'));
    salaryCategories.containerClass = 'salary-dropdown';
    salaryCategories.dropdownTitleId = 'salary-dropdown-title';
    salaryCategories.dropdownDefaultTitle = 'Salary';
    salaryCategories.dropdownTitleMany = ' salary options';
    salaryCategories.dropdownToggleElement = document.querySelector('.toggle-salary');
    salaryCategories.clearElement = document.querySelector('.salary-filter .dropdown-clear-icon');
    salaryCategories.init();
}

if (document.querySelector('.contract-dropdown')) {
    var contractCategories = new FoldingCategories(document.querySelector('.contract-dropdown'));
    contractCategories.containerClass = 'contract-dropdown';
    contractCategories.dropdownTitleId = 'contract-dropdown-title';
    contractCategories.dropdownDefaultTitle = 'Employment Type';
    contractCategories.dropdownTitleMany = ' employment type';
    contractCategories.dropdownToggleElement = document.querySelector('.toggle-contract');
    contractCategories.clearElement = document.querySelector('.contract-filter .dropdown-clear-icon');
    contractCategories.init();
}

if (document.querySelector('.favorite-dropdown')) {
    var favoriteCategories = new FoldingCategories(document.querySelector('.favorite-dropdown'));
    favoriteCategories.containerClass = 'favorite-dropdown';
    favoriteCategories.dropdownTitleId = 'favorite-dropdown-title';
    favoriteCategories.dropdownDefaultTitle = 'My Favorites';
    favoriteCategories.dropdownToggleElement = document.querySelector('.toggle-favorite');
    favoriteCategories.clearElement = document.querySelector('.favorite-filter .dropdown-clear-icon');
    favoriteCategories.init();
}

if (document.querySelector('#filter_mobile .sector-dropdown')) {
    var sectorCategoriesMobile = new FoldingCategories(document.querySelector('#filter_mobile .sector-dropdown'));
    sectorCategoriesMobile.containerClass = 'sector-dropdown';
    sectorCategoriesMobile.dropdownTitleId = 'sector-dropdown-title-mobile';
    sectorCategoriesMobile.enableChildrenCategories = true;
    sectorCategoriesMobile.enableSelectionCounter = true;
    sectorCategoriesMobile.enableSaveState = false;
    sectorCategoriesMobile.dropdownTitleMany = ' sectors';
    sectorCategoriesMobile.dropdownToggleElement = document.querySelector('#filter_mobile .toggle-sectors');
    sectorCategoriesMobile.init();
}

if (document.querySelector('#filter_mobile .salary-dropdown')) {
    var salaryCategoriesMobile = new FoldingCategories(document.querySelector('#filter_mobile .salary-dropdown'));
    salaryCategoriesMobile.containerClass = 'salary-dropdown';
    salaryCategoriesMobile.dropdownTitleId = 'salary-dropdown-title-mobile';
    salaryCategoriesMobile.dropdownDefaultTitle = 'Salary';
    salaryCategoriesMobile.dropdownTitleMany = ' salary options';
    salaryCategoriesMobile.enableSaveState = false;
    salaryCategoriesMobile.dropdownToggleElement = document.querySelector('#filter_mobile .toggle-salary');
    salaryCategoriesMobile.init();
}

if (document.querySelector('#filter_mobile .contract-dropdown')) {
    var contractCategoriesMobile = new FoldingCategories(document.querySelector('#filter_mobile .contract-dropdown'));
    contractCategoriesMobile.containerClass = 'contract-dropdown';
    contractCategoriesMobile.dropdownTitleId = 'contract-dropdown-title-mobile';
    contractCategoriesMobile.dropdownDefaultTitle = 'Contract Type';
    contractCategoriesMobile.dropdownTitleMany = ' contract options';
    contractCategoriesMobile.enableSaveState = false;
    contractCategoriesMobile.dropdownToggleElement = document.querySelector('#filter_mobile .toggle-contract');
    contractCategoriesMobile.init();
}

if (document.querySelector('#filter_mobile .favorite-dropdown')) {
    var favoriteCategoriesMobile = new FoldingCategories(document.querySelector('#filter_mobile .favorite-dropdown'));
    favoriteCategoriesMobile.containerClass = 'favorite-dropdown';
    favoriteCategoriesMobile.dropdownTitleId = 'favorite-dropdown-title-mobile';
    favoriteCategoriesMobile.dropdownDefaultTitle = 'My Favorites';
    favoriteCategoriesMobile.enableSaveState = false;
    favoriteCategoriesMobile.dropdownToggleElement = document.querySelector('#filter_mobile .toggle-favorite');
    favoriteCategoriesMobile.init();
}
